import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { IUserLoginRequest } from "../models/IUserLoginRequest";
import { jwtDecode } from 'jwt-decode';
import {
  BehaviorSubject,
  firstValueFrom,
  Observable,
  of,
  Subject,
  Subscription,
} from "rxjs";
import { JwtHelperService } from "@auth0/angular-jwt";
import { IUserToken } from "../models/IUserToken";
import { environment } from "../../../../environments/environment";
import { NewPasswordModel } from "../models/new-password.model";
import { SendRecoveryPasswordMailRequest } from "../models/SendRecoveryPasswordMailRequest.model";
import { AuthAPIService } from "../../shared/services/API/AuthAPI.service";

@Injectable({
  providedIn: "root",
})
export class AuthService implements OnInit, OnDestroy {
  private userId: string = "";
  public isAuthenticated: Observable<boolean>;
  public isReloading = false;
  formLogin: any;
  configUrl: string;
  requestUrl: any;
  requestToken: any;
  subscription_GetRefreshToken: Subscription;
  subscription_CheckAccess: Subscription;
  private role$: Subject<string[]> = new Subject();

  subscription_SetClients: any;


  constructor(
    private router: Router,
    private jwtHelper: JwtHelperService,
    private authService: AuthAPIService
  ) {
    this.configUrl = environment.host;
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    if (this.subscription_CheckAccess)
      this.subscription_CheckAccess.unsubscribe();
    if (this.subscription_GetRefreshToken)
      this.subscription_GetRefreshToken.unsubscribe();
  }

  setRole(resp) {
    this.role$.next(resp);
  }
  getRole() {
    return this.role$.asObservable();
  }

  checkAuthenticated(): Observable<boolean> {
    let resp = false;
      // this.router.events.subscribe((val) => {
    //   if (val instanceof NavigationEnd) {
    //     this.requestToken = val.urlAfterRedirects.split("token=")[1];

      
    // });
    //Verifica que haya variable token
    console.log("Checando Token...");
    //buscando token por url
    this.requestUrl = this.router.parseUrl(this.router.url);
    this.requestToken = this.requestUrl.queryParams["token"];
  
  if(this.requestToken == undefined){
    this.requestToken = window.location.href.split("token=")[1];
  }
    if (this.requestToken === undefined) {
      this.requestToken = "";
    } else {
      console.log("----Seteando Token por URL----");
      console.log("RequestToken", this.requestToken);
      localStorage.setItem("token", this.requestToken);
      localStorage.setItem("userName", this.getUserDecoded(this.requestToken));
      console.log("hay token?", localStorage.getItem("userName"), this.getUserDecoded(this.requestToken)); 
      if (localStorage.getItem("userName") === undefined || localStorage.getItem("userName") === null || localStorage.getItem("userName") === "") {
        console.log("----Token no valido----"); 
        sessionStorage.setItem("error", "token");
        this.router.navigate(["/error"]);
      }else{
        this.router.navigate(["/callback"]);
        resp = true;
      }
      
    }
    //VERIFICAR SI EL TOKEN VIENE POR URL SINO TOMAR EL ALMACENADO
    if (localStorage.getItem("token") !== undefined && sessionStorage.getItem("error") !== "token") {
      var token = localStorage.getItem("token");
      //Verifica que el token esté seteado
      if (
        token == "null" ||
        token == undefined ||
        token == null ||
        token == ""
      ) {
        this.requestUrl = this.router.parseUrl(this.router.url);
        this.requestToken = this.requestUrl.queryParams["token"];
        console.log("----Token Nulo----",this.requestToken);
        if (this.requestToken == undefined) {
          this.requestToken = "";
          //this.router.navigateByUrl("/login");
        } else {
          console.log("----Seteando Token por URL----");
          console.log("RequestToken", this.requestToken);
          localStorage.setItem("token", this.requestToken);
          localStorage.setItem("userName", this.getUserDecoded(this.requestToken));
          resp = true;
        }
      } else {
        console.log("Token Encontrado...");
        //Verifica que el token no esté expirado
        try {
          var isTokenExpired = this.jwtHelper.isTokenExpired(token);
        } catch (error) {
          isTokenExpired = true;
        }
        if (isTokenExpired) {
          console.log("**********TOKEN EXPIRED*******");
          if (this.requestToken !== undefined ) {
            console.log("----Seteando Token por URL----");
            console.log("RequestToken", this.requestToken);
            localStorage.setItem("token", this.requestToken);
            localStorage.setItem("userName", this.getUserDecoded(this.requestToken));
            resp = true;
          } else {
            const TOKEN: IUserToken = {
              token: token,
            };
            this.subscription_GetRefreshToken = this.getRefreshToken(
              TOKEN
            ).subscribe((resp) => {
              if (resp.result != null) var userToken: IUserToken;
              userToken = resp.result;
              localStorage.setItem("token", userToken.token);
              document.location.reload();
              console.log(resp);
            });
          }
        } else {
          console.log("*******SESSION TOKEN*******************");
          localStorage.setItem("token", token);
          this.getUserDecoded(token);
          resp = true;
        }
      }
    } else {
      console.log("Token no proporcionado");
    }

  

    return of(resp);
  }
  getUserDecoded(requestToken: any): string {
    var decode = this.getDecodedAccessToken(requestToken);
    this.userId = decode?.Id || "";
    if (decode == null)
      return "";
    return decode.email;
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch(Error) {
      return null;
    }
  }
  getRefreshToken(token: any) {
    return this.authService.getRefreshToken(token);
  }

  checkAccess() {
    var access = false;
    this.subscription_CheckAccess = this.checkAuthenticated().subscribe(
      (arg) => (access = arg)
    );
  }

  Login(usuarioLogin: IUserLoginRequest): any {
    return this.authService.Login(usuarioLogin);
  }

  async Logout(): Promise<void> {
    try {
      console.log("Cerrando Sesion");
      localStorage.setItem("token", "");
      localStorage.setItem("bloqueoGPS", "");
      localStorage.setItem("desbloqueoGPS", "");
      localStorage.setItem("user", "");
      localStorage.setItem("userName", "");
      localStorage.setItem("userRol", "");
      localStorage.setItem("listaClientes", "");
      localStorage.setItem("ClienteSeleccionado", "");
      localStorage.setItem("ClienteSeleccionadoId", "");
      localStorage.setItem("views", "");
      localStorage.setItem("UrlList", "");
      localStorage.setItem("listaCategorias", "");
      localStorage.setItem("permissions", "");
      localStorage.setItem("ShownTutorials", "");
      localStorage.setItem("SystemNotification", "");
      localStorage.setItem("settingsSelectedTab", "");
      await this.router.navigate(["/login"]);
      //location.reload();
    } catch (err) {
      console.error(err);
    }
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  getUserId(): string {
    return this.userId;
  }

  resetPassword(objResetPassword: NewPasswordModel){
    return this.authService.resetPassword(objResetPassword);
  }
    
  sendRecoveryPasswordEmail(objSendPasswordRecoveryMail: SendRecoveryPasswordMailRequest){
    return this.authService.sendRecoveryPasswordEmail(objSendPasswordRecoveryMail);
  }

  UpdateDefaultClientId() {
    return this.authService.UpdateDefaultClientId();
  }

  UpdateClientId(client: any) {
    return this.authService.UpdateClientId(client);
  }
}
